<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'subject',
    navActiveLink: 'subjects',
  },
})

import { useSnackBar } from '@/utils/stores/snackbar'
import SubjectList from "@/views/assignment/view/subjectList.vue"
import TabIndex from "@/views/assignment/view/tabIndex.vue"

// subject list 에서 선택한 subject로 tabindex에 넣어준다.
// tabindex -> title에 넣고 id를 또 내려줌.

const snackbarStore = useSnackBar()
const selectedSubject = ref({})

const selectSubject = value => {
  selectedSubject.value = value
}

onMounted(() => {
  snackbarStore.showSnackBar("각 아이콘을 누르면 기록 입력화면으로 이동합니다.")
})
</script>

<template>
  <VRow>
    <VCol cols="12">
      <VCard class="mt-5">
        <VCardText>
          <VRow>
            <VCol
              cols="12"
              md="2"
              style="max-inline-size:250px"
            >
              <SubjectList @select-subject="selectSubject" />
            </VCol>
            <VCol
              cols="12"
              md="10"
            >
              <TabIndex :selected-subject="selectedSubject" />
            </VCol>
          </VRow>
        </VCardText>
      </VCard>
    </VCol>
  </VRow>
</template>
